/* Ergovanta collection-page enhancements (2026-06-23).
   - Rename the custom.shop_category facet to "Browse by Category".
   - Replace the min/max price inputs with a dual-handle range slider that
     drives those inputs (Horizon auto-applies the facet on change).
   Self-guards to /collections/ pages; re-applies after facet AJAX re-renders. */
(function () {
  if (!/\/collections\//.test(location.pathname)) return;
  var CAT = '[name="filter.p.m.custom.shop_category"]';

  function renameCategory() {
    document.querySelectorAll('accordion-custom.facets__item').forEach(function (it) {
      if (!it.querySelector(CAT)) return;
      var lbl = it.querySelector('.facets__label');
      if (lbl && lbl.textContent.trim() !== 'Browse by Category') lbl.textContent = 'Browse by Category';
    });
  }

  function money(v) { return '$' + Math.round(v).toLocaleString(); }

  function buildPriceSlider() {
    document.querySelectorAll('price-facet-component').forEach(function (pf) {
      if (pf.hasAttribute('data-eg-slider')) return;
      var gte = pf.querySelector('[name="filter.v.price.gte"]');
      var lte = pf.querySelector('[name="filter.v.price.lte"]');
      if (!gte || !lte) return;
      pf.setAttribute('data-eg-slider', '1');

      var min = Math.floor(parseFloat(gte.getAttribute('data-min') || '0'));
      var max = Math.ceil(parseFloat(lte.getAttribute('data-max') || gte.getAttribute('data-max') || '1000'));
      if (!(max > min)) max = min + 1000;
      var step = Math.max(1, Math.round((max - min) / 200));
      var curLo = gte.value !== '' ? parseFloat(gte.value) : min;
      var curHi = lte.value !== '' ? parseFloat(lte.value) : max;

      var wrap = document.createElement('div');
      wrap.className = 'eg-price-slider';
      wrap.innerHTML =
        '<div class="eg-price-slider__values"><span class="eg-price-slider__lo"></span><span class="eg-price-slider__hi"></span></div>' +
        '<div class="eg-price-slider__rail"><div class="eg-price-slider__fill"></div>' +
        '<input type="range" class="eg-price-slider__thumb eg-price-slider__thumb--lo" min="' + min + '" max="' + max + '" step="' + step + '" aria-label="Minimum price">' +
        '<input type="range" class="eg-price-slider__thumb eg-price-slider__thumb--hi" min="' + min + '" max="' + max + '" step="' + step + '" aria-label="Maximum price"></div>';
      pf.insertBefore(wrap, pf.firstChild);

      var lo = wrap.querySelector('.eg-price-slider__thumb--lo');
      var hi = wrap.querySelector('.eg-price-slider__thumb--hi');
      var fill = wrap.querySelector('.eg-price-slider__fill');
      var loLbl = wrap.querySelector('.eg-price-slider__lo');
      var hiLbl = wrap.querySelector('.eg-price-slider__hi');
      lo.value = curLo; hi.value = curHi;

      function render() {
        var a = parseFloat(lo.value), b = parseFloat(hi.value);
        if (a > b) {
          if (document.activeElement === lo) { a = b; lo.value = a; }
          else { b = a; hi.value = b; }
        }
        var pa = ((a - min) / (max - min)) * 100, pb = ((b - min) / (max - min)) * 100;
        fill.style.left = pa + '%'; fill.style.right = (100 - pb) + '%';
        loLbl.textContent = money(a); hiLbl.textContent = money(b);
        lo.style.zIndex = a > min + (max - min) * 0.9 ? 5 : 3;
        return [a, b];
      }
      function apply() {
        var r = render(), a = r[0], b = r[1];
        gte.value = a <= min ? '' : a;
        lte.value = b >= max ? '' : b;
        [gte, lte].forEach(function (el) {
          el.dispatchEvent(new Event('input', { bubbles: true }));
          el.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
      lo.addEventListener('input', render);
      hi.addEventListener('input', render);
      lo.addEventListener('change', apply);
      hi.addEventListener('change', apply);
      render();
    });
  }

  // When a color filter is active, make each product card show THAT color's
  // variant image first. The cards already carry per-color swatch buttons with
  // data-eg-swatch-img (the variant photo) + aria-label (the color name), so this
  // is just a src swap - no per-product fetch needed.
  function applyColorSwap() {
    var params = new URLSearchParams(location.search);
    var colors = params.getAll('filter.v.option.color');
    if (!colors.length) return;
    var target = colors[0].toLowerCase();
    document.querySelectorAll('.product-card').forEach(function (card) {
      var swatches = card.querySelectorAll('.eg-card-swatch');
      if (!swatches.length) return;
      var match = null;
      Array.prototype.forEach.call(swatches, function (s) {
        if (!match && (s.getAttribute('aria-label') || '').toLowerCase() === target) match = s;
      });
      if (!match) return;
      var img = match.getAttribute('data-eg-swatch-img');
      if (!img) return;
      if (img.indexOf('//') === 0) img = location.protocol + img;
      var mainImg = card.querySelector('.product-media__image') || card.querySelector('.product-media img') || card.querySelector('.card-gallery img');
      if (mainImg && mainImg.getAttribute('src') !== img) {
        mainImg.setAttribute('src', img);
        mainImg.setAttribute('srcset', img);
      }
      Array.prototype.forEach.call(swatches, function (s) { s.classList.remove('is-active'); });
      match.classList.add('is-active');
    });
  }

  function applyAll() { renameCategory(); buildPriceSlider(); applyColorSwap(); }

  function init() {
    applyAll();
    // One-time backup in case the facets hydrate slightly after DOMContentLoaded.
    // IMPORTANT: do NOT run a persistent MutationObserver here. Horizon updates the
    // facets with the View Transitions API; mutating the DOM (renaming the label /
    // rebuilding the slider) mid-transition aborts it ("InvalidStateError: Transition
    // was aborted") and makes the filter dropdowns feel broken. The slider + rename
    // survive Horizon's in-place facet updates, so they only need applying once.
    setTimeout(applyAll, 400);
    document.addEventListener('shopify:section:load', applyAll);
    // Re-apply the color -> variant-image swap when a filter changes (Horizon
    // re-renders the grid via pushState). Poll the URL rather than observe the grid,
    // so we never mutate it mid view-transition; re-apply twice once it settles. Only
    // acts on a URL change, so it never fights swatch hover.
    var lastSearch = location.search;
    setInterval(function () {
      if (location.search !== lastSearch) {
        lastSearch = location.search;
        setTimeout(applyColorSwap, 320);
        setTimeout(applyColorSwap, 780);
      }
    }, 350);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
